import { ProcessInstanceRestartApi } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import Uuid from '../../model/Uuid';

const client = new ProcessInstanceRestartApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const restartProcessInstance = async (
  uuid: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.restartProcessInstance(uuid, headers);
  return {
    responseCode: status,
  };
};
